import { render, staticRenderFns } from "./AdminLinks.vue?vue&type=template&id=1ff72fa4&scoped=true&"
import script from "./AdminLinks.vue?vue&type=script&lang=js&"
export * from "./AdminLinks.vue?vue&type=script&lang=js&"
import style0 from "./AdminLinks.vue?vue&type=style&index=0&id=1ff72fa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff72fa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff72fa4')) {
      api.createRecord('1ff72fa4', component.options)
    } else {
      api.reload('1ff72fa4', component.options)
    }
    module.hot.accept("./AdminLinks.vue?vue&type=template&id=1ff72fa4&scoped=true&", function () {
      api.rerender('1ff72fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminLinks.vue"
export default component.exports